<template>
  <label class="vcheckbox" :class="[{'is-checked': isChecked}, {error: error}]">
    <input
      v-bind="$attrs"
      class="vcheckbox__original"
      type="checkbox"
      v-model="model"
      @focus="focus = true"
      @blur="focus = false"
    />
  </label>
</template>
<script>
export default {
  name: 'VCheckbox',
  inheritAttrs: false,
  props: {
    value: Boolean,
    error: Boolean,
  },
  data() {
    return {
      selfModel: false,
      focus: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.value !== undefined ? this.value : this.selfModel;
      },
      set(val) {
        this.$emit('input', val);
        this.selfModel = val;
      },
    },
    isChecked() {
      return this.model;
    },
  },
};
</script>
<style scoped>
.vcheckbox {
  position: relative;
  width: 24px;
  height: 24px;
  border: 1px solid var(--grey);
  display: inline-block;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 5px;
}
.vcheckbox.error {
  border: 1px solid var(--accent);
}
.vcheckbox:after {
  content: '';
  display: inline-block;
  width: 10px;
  height: 13px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  border-radius: 0px;
  margin: 0px 0px 5px 6px;
  opacity: 0;
}
.vcheckbox.error:after {
  border: solid var(--accent);
}
.vcheckbox.is-checked {
  border: 1px solid var(--brand-color);
  background: var(--brand-color);
}
.vcheckbox.is-checked:after {
  opacity: 1;
}
.vcheckbox input {
  opacity: 0;
  position: absolute;
}
</style>
